import { createContext, use } from "react";
import { IRootStore, rootStore } from "./rootStore";

export const RootStoreContext = createContext<IRootStore>(rootStore);

export const useStore = () => use(RootStoreContext);
